<template>
  <main class="record-page">
    <header class="record-header">
      <div class="record-header-glow"></div>
      <h1>流量购买记录</h1>
    </header>

    <section class="record-list">
      <article class="record-card" v-for="item in list" :key="item.id">
        <div class="row row-top">
          <h2>{{ item.package ? item.package.title : "-" }}</h2>
          <span class="status" :class="item.refund_status === 0 ? 'paid' : 'cancelled'">{{ item.refund_status === 0 ? "已支付" : "已退款" }}</span>
        </div>
        <div class="row row-mid">
          <p class="plan">{{ item.packagetype ? item.packagetype.name : "-" }}</p>
          <p class="price">{{ item.price }}元</p>
        </div>
        <p class="meta">账期开始：{{ item.startDate }} 00:00:00</p>
        <p class="meta">账期结束：{{ item.endDate }} 59:59:59</p>
        <p class="meta">订单号：{{ item.order_sn }}</p>
      </article>
    </section>

    <p class="no-more" v-if="finished || !list.length">没有更多了～</p>
  </main>
</template>

<script>
export default {
  name: "orderNew",
  data () {
    return { loading: false, finished: false, error: false, list: [] }
  },
  methods: {
    loadData () {
      this.error = false
      this.loading = true
      this.fetchData("/order/index", { iccid: sessionStorage.getItem("iccid") }, (res) => {
        this.loading = false
        if (res.code) {
          this.list = res.data.data || []
          this.finished = res.data.current_page >= res.data.last_page
        } else {
          this.error = true
          this.$toast.fail("加载失败")
        }
      })
    }
  },
  created () {
    this.loadData()
  }
}
</script>

<style scoped src="./static/css/package-record.css"></style>



// WEBPACK FOOTER //
// src/newpage/order.vue